/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Kbd_CloseInputs */

const en_us2_search_kbd_close = /** @type {(inputs: Search_Kbd_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`close`)
};

const pt_br2_search_kbd_close = /** @type {(inputs: Search_Kbd_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fechar`)
};

const es_419_search_kbd_close = /** @type {(inputs: Search_Kbd_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cerrar`)
};

const pt_pt2_search_kbd_close = /** @type {(inputs: Search_Kbd_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fechar`)
};

const fr_fr2_search_kbd_close = /** @type {(inputs: Search_Kbd_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fermer`)
};

const de_de2_search_kbd_close = /** @type {(inputs: Search_Kbd_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`schließen`)
};

const it_it2_search_kbd_close = /** @type {(inputs: Search_Kbd_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chiudi`)
};

/**
* | output |
* | --- |
* | "close" |
*
* @param {Search_Kbd_CloseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_kbd_close = /** @type {((inputs?: Search_Kbd_CloseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Kbd_CloseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_kbd_close(inputs)
	if (locale === "es-419") return es_419_search_kbd_close(inputs)
	if (locale === "pt-PT") return pt_pt2_search_kbd_close(inputs)
	if (locale === "fr-FR") return fr_fr2_search_kbd_close(inputs)
	if (locale === "de-DE") return de_de2_search_kbd_close(inputs)
	if (locale === "it-IT") return it_it2_search_kbd_close(inputs)
	return en_us2_search_kbd_close(inputs)
});
export { search_kbd_close as "search.kbd_close" }